export default "__VITE_ASSET__mUdN8$i2b$ZFy3ldtf4jcQ__"